// Small shared helpers.

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

// "2025-01" -> "JAN 2025". Anything else is returned as-is.
export function fmtMonth(dateStr) {
  if (!dateStr) return "—";
  const [y, m] = dateStr.split("-");
  const idx = parseInt(m, 10) - 1;
  if (y && idx >= 0 && idx < 12) return `${MONTHS[idx]} ${y}`;
  return dateStr;
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}
